import React from "react";
import {useTranslation} from "react-i18next";


const PostPhotoCuter = ({index, image, handleDeleteImage}) => {
	const {t} = useTranslation();

	const handleUpdateImage = () => {

	};

	return (
			<div
				className='mb-2'
				// className='border-b border-violet-900 mb-3 rounded-lg'
			>
				<img
						className="m-auto rounded-2xl"
						alt="preview image"
						src={URL.createObjectURL(image)}
				/>
				<div className='mt-1 mb-2 flex items-center justify-evenly gap-2.5'>
					<p className={`text-center text-sm text-gray-500 ${(image.size / 1024).toFixed() > 10000 ? 'text-red-500' : ''}`}>
						{(image.size / 1024).toFixed(2)} KB
						{(image.size / 1024).toFixed() > 10000 ?
								<span className='block text-xs'>{t("post.bigFileSize")}</span> : ''}
					</p>
					<button
							onClick={() => handleDeleteImage(index)}
							className="p-0 bg-red-500 text-xs text-white rounded-lg px-2 py-0.5 hover:bg-red-600"
					>
						{t("post.remove")}
					</button>
				</div>
			</div>
	);
};

export default PostPhotoCuter;